import { CheckboxField } from '@/types/forms/fields/checkboxField';
import { RadioButtonsField } from '@/types/forms/fields/radioButtonsField';
import { SelectField } from '@/types/forms/fields/selectField';
import { TextField } from '@/types/forms/fields/textField';
import { FormElement } from '@/types/forms/formElement';
import { FormOption } from '@/types/forms/formOption';
import { MeasuringConceptsFormStep } from '@/types/forms/formSteps/measuringConceptsFormStep';
import { checked } from '@/validators/checked';
import { float } from '@/validators/float';
import { mustBeLowerThanOrEqualToSelfGenerationQuantity } from '@/validators/mustBeLowerThanOrEqualToSelfGenerationQuantity';
import { mustBeNoMoreThan20PercentAboveSuggestion } from '@/validators/mustBeNoMoreThan20PercentAboveSuggestion';
import { positive } from '@/validators/positive';
import { alphaNum, maxLength, required } from 'vuelidate/lib/validators';
import { cloneDeep as _cloneDeep } from 'lodash';
import { MeasuringConceptOperatingModeType } from '@/types/forms/shared/measuringConceptsOperatingModeType';
import { SupplyConceptType } from '@/types/forms/shared/supplyConceptType';
import { TransferMeterType } from '@/types/forms/shared/transferMeterType';

const operatingMode = new SelectField<MeasuringConceptOperatingModeType>({
    options: [
        new FormOption({ key: 'fullInfeed' }),
        new FormOption({ key: 'surplusInfeed' }),
        new FormOption({ key: 'zeroInfeed' }),
        new FormOption({ key: 'commercialTransfer' }),
    ],
    validators: {
        required,
    },
});

const operatingModeStorage = _cloneDeep(operatingMode);

export const measuringConceptsFormStep = new MeasuringConceptsFormStep({
    operatingMode,
    operatingModeStorage,
    fullInfeedBonusHeadline: new FormElement(),
    fullInfeedBonus: new CheckboxField(),
    measuringPointOperatorInfo: new FormElement(),
    meterNumber: new TextField({
        validators: {
            required,
            alphaNum,
            maxLength: maxLength(14),
        },
    }),
    measuringPointOperation: new RadioButtonsField({
        value: 'ewe',
        options: [
            new FormOption({ key: 'ewe' }),
            new FormOption({ key: 'other' }),
        ],
        validators: {
            required,
        },
    }),
    measuringPointOperator: new SelectField<string>({
        hasServiceDrivenOptions: true,
        validators: {
            required,
        },
    }),
    priceSheetMeasuringPointOperation: new FormElement(),
    specialSupplyConcept: new CheckboxField(),
    specialSupplyConceptInfo: new FormElement(),
    specialSupplyConceptAcknowledgement: new CheckboxField({
        value: false,
        validators: { checked },
    }),
    supplyConceptType: new RadioButtonsField<SupplyConceptType>({
        options: [
            new FormOption({ key: 'tenantElectricity' }),
            new FormOption({ key: 'communalBuildingSupply' }),
        ],
        validators: {
            required,
        },
    }),
    transferMeterType: new RadioButtonsField<TransferMeterType>({
        options: [
            new FormOption({ key: 'virtualSummaryMeter' }),
            new FormOption({ key: 'physicalSummaryMeter' }),
        ],
        validators: {
            required,
        },
    }),
    measuringPointOperationInfoEwe: new FormElement(),
    measuringPointOperationInfoOther: new FormElement(),
    minorConsumptionAllocation: new CheckboxField({
        value: false,
    }),
    noExtraConsumption: new CheckboxField({
        value: false,
        validators: { checked },
    }),
    operatorIdentityMatch: new CheckboxField({
        value: false,
        validators: { checked },
    }),
    additionalMeterNumber: new TextField({
        validators: {
            required,
            alphaNum,
            maxLength: maxLength(14),
        },
    }),
    selfGenerationQuantity: new TextField({
        value: '0,00',
        validators: {
            required,
            float,
            positive,
            mustBeNoMoreThan20PercentAboveSuggestion,
        },
    }),
    selfSupplyQuantity: new TextField({
        value: '0,00',
        validators: {
            required,
            float,
            positive,
            mustBeLowerThanOrEqualToSelfGenerationQuantity,
        },
    }),
    remainingElectricityInfo: new FormElement(),
    storageHeadline: new FormElement(),
});
